
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcdc as ObiConverterDcdcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcdc.js';
 
 
 

 
 export const ObiConverterDcdc = createComponent({
   react: React,
   tagName: 'obi-converter-dcdc',
   elementClass: ObiConverterDcdcElement,
   events: {
     
   }
  });
 
 